module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "selected": _vm.selected
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "arrow arrow-left",
    on: {
      "click": function($event) {
        return _vm.onClickPrevious()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-right",
    on: {
      "click": function($event) {
        return _vm.onClickNext()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "label pull-right",
    class: _vm.unitClass
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.period))])])]), _vm._v(" "), (_vm.processStats.length) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.received).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold text-success",
    class: {
      'text-success': _vm.growth > 0, 'text-danger': _vm.growth < 0
    }
  }, [_vm._v("\n      " + _vm._s(Math.round(_vm.growth)) + "%\n      "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.growth > 0, 'fa-level-down': _vm.growth < 0
    }
  })]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processStats,
      "gradient": ['#683090', '#c97eff'],
      "height": 60,
      "auto-draw": ""
    }
  })], 1)]) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content-loader")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3187a24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/AnalyticsUnitBlock.vue
// module id = 3423
// module chunks = 3